// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"7331f315","404":"622dfada","424":"7331f315","652":"7331f315","781":"a01ae8ff","872":"7331f315","957":"cb6ee934"}[chunkId] + ".chunk.css";
};